(function () {
  function initFooterNewsletter(root) {
    const wrap = root.querySelector('.footer-canvas__newsletter');
    if (!wrap) return;

    // Prevent double init
    if (wrap.dataset.footerNewsletterInit === '1') return;
    wrap.dataset.footerNewsletterInit = '1';

    const form = wrap.querySelector('form.footer-canvas__form');
    const input = wrap.querySelector('.footer-canvas__input');
    if (!form || !input) return;

    const defaultPlaceholder =
      input.getAttribute('placeholder') || 'SUBSCRIBE TO OUR NEWSLETTER';
    const activePlaceholder = 'ENTER YOUR EMAIL';
    const successPlaceholder = 'THANKS FOR SUBSCRIBING!';

    function setInactive() {
      wrap.classList.remove('is-active');
      input.setAttribute('placeholder', defaultPlaceholder);
    }

    function activate() {
      // If already subscribed, do nothing
      if (wrap.classList.contains('is-success')) return;

      wrap.classList.add('is-active');
      input.setAttribute('placeholder', activePlaceholder);
      input.focus();

      // Keep cursor at end
      const v = input.value;
      input.value = '';
      input.value = v;
    }

    function setSuccess() {
      wrap.classList.add('is-success');
      wrap.classList.remove('is-active');
      input.value = '';
      input.setAttribute('placeholder', successPlaceholder);
      input.blur();
    }

    function deactivateIfEmpty() {
      if (wrap.classList.contains('is-success')) return;
      if (input.value.trim() !== '') return;
      setInactive();
    }

    // Click anywhere on the bar activates (but not on links/buttons/inputs)
    wrap.addEventListener('click', (e) => {
      if (e.target.closest('a, button, input, textarea, select, label')) return;
      activate();
    });

    input.addEventListener('focus', () => {
      if (!wrap.classList.contains('is-active')) activate();
    });

    input.addEventListener('blur', () => {
      setTimeout(deactivateIfEmpty, 120);
    });

    // AJAX submit to prevent page refresh + scroll jump
    form.addEventListener('submit', async (e) => {
      e.preventDefault();

      if (wrap.classList.contains('is-success')) return;

      const email = (input.value || '').trim();
      if (!email) {
        activate();
        return;
      }

      try {
        const formData = new FormData(form);

        // Use the form's actual action, not the current page URL (e.g. /cart)
        const actionRaw = form.getAttribute('action') || window.location.pathname;
        const action = actionRaw.split('#')[0]; // strip any anchors like #contact_form

        const res = await fetch(action, {
          method: 'POST',
          body: formData,
          headers: { Accept: 'text/html' },
          credentials: 'same-origin',
        });

        if (res.ok) {
          setSuccess();
        } else {
          activate();
        }
      } catch (err) {
        activate();
      }
    });

    // If Shopify rendered success state server-side, mirror UI
    const successEl = wrap.querySelector('.footer-canvas__message--success');
    if (successEl) setSuccess();
  }

  document.addEventListener('DOMContentLoaded', function () {
    initFooterNewsletter(document);
  });

  // Re-init when Shopify loads sections dynamically (Theme Editor + section render)
  document.addEventListener('shopify:section:load', function (event) {
    initFooterNewsletter(event.target);
  });
})();